import { Box } from '@mui/material';
import React from 'react';

interface BottomDrawerTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  drawerOpen: boolean;
}

const BottomDrawerTabPanel = ({ children, value, index, drawerOpen }: BottomDrawerTabPanelProps) => {
  const isActivePanel = drawerOpen && value === index;

  return (
    <Box
      role="tabpanel"
      hidden={!isActivePanel}
      id={`bottom-bar-tabpanel-${index}`}
      aria-labelledby={`bottom-bar-tab-${index}`}
      sx={{ bgcolor: 'background.console', width: '100%' }}
    >
      {isActivePanel && <Box sx={{ bgcolor: 'background.console', width: '100%' }}>{children}</Box>}
    </Box>
  );
};

export default BottomDrawerTabPanel;
